import { parseQueryString, replaceQueryString } from "@common/lib/url";
import { type VzaarVideoProps } from "./component";

export const getSrc = (props: VzaarVideoProps): string => {
  let url = props.url || `//view.vzaar.com/${props.videoId}/player`;

  const qs = parseQueryString(url) || {};
  if (url.includes("//vzaar")) {
    const match = url.match(/\/\/vzaar.tv\/([^/?]+)/) || url.match(/\/\/vzaar.com\/videos\/([^/?]+)/);
    url = `//view.vzaar.com/${match![1]}/player`;
  }

  if (props.isBackground) {
    return replaceQueryString(url, {
      ...qs,
      autoMute: true,
      autoplay: true,
      hideControls: true,
      looping: true,
      kioskMode: true
    });
  }

  return replaceQueryString(url, {
    ...qs,
    autoMute: props.autoPlay ? 1 : props.mute,
    autoplay: props.autoPlay,
    hideControls: props.showControls,
    looping: props.loop
  });
};

export const isVzaarURL = (url: string | null | undefined) =>
  (url || "").includes("//vzaar") || (url || "").includes("//view.vzaar");
